<template>
   <div>
      <label :for="`number-text-box-${id}`" class="label-text" :class="{ 'sr-only': ariaOnlyLabel }">{{ label }}</label>
      <input
         :id="`number-text-box-${id}`"
         :placeholder="placeholder"
         :value="modelValue"
         inputmode="numeric"
         :data-cy="`number-text-box-${id}`"
         class="input w-full appearance-none rounded-lg border box-border border-grey-20 bg-grey-10 px-4 py-2 text-black"
         :class="{ 'has-error': props.hasError }"
         type="text"
         :maxlength="maxLength"
         :disabled="isDisabled"
         @input="onInput"
      />
   </div>
</template>

<script setup lang="ts">
import { slugify } from "@/js/helpers/slugify";

const props = defineProps({
   modelValue: {
      type: String,
      default: "",
   },
   label: {
      type: String,
      required: true,
   },
   maxLength: {
      type: Number,
      required: false,
   },
   hasError: {
      type: Boolean,
      default: false,
   },
   placeholder: {
      required: false,
      type: String,
   },
   ariaOnlyLabel: {
      type: Boolean,
      default: false,
   },
   isDisabled: {
      type: Boolean,
      default: false,
   },
});

const emit = defineEmits(["update:modelValue", "change"]);

// computed
//-----------------------------------------------
const id = computed(() => slugify(props.label));

// methods
//-----------------------------------------------
function onInput(event) {
   emit("update:modelValue", event.target.value);
   emit("change", event.target.value);
}
</script>

<style scoped>
.has-error {
   @apply !border-error-red;
}

.label-text {
   font-size: 1rem;
   margin-bottom: 0.25rem;
   display: block;
   text-transform: capitalize;
}
</style>
